import { ref, listAll, getDownloadURL } from "firebase/storage";
import storage from "./firebaseConfig";
import { doc, setDoc, updateDoc, increment } from "firebase/firestore";
import { firestore } from "./firebaseConfig";
import { musicStorage } from "./firebaseConfig";

export const fetchFolderContents = async (folderPath = "") => {
    const folderRef = ref(storage, folderPath);
    const folderContents = await listAll(folderRef);
  
    const folders = folderContents.prefixes.map((prefix) => ({
      name: prefix.name,
      path: prefix.fullPath,
      type: "folder",
    }));
  
    const files = await Promise.all(
      folderContents.items.map(async (item) => {
        const url = await getDownloadURL(item);
        const safeDocId = item.fullPath.replaceAll("/", "|");
        const docRef = doc(firestore, "musics", safeDocId);
        await setDoc(docRef, {
          name: item.name,
          path: item.fullPath,
          url
        }, { merge: true });
  
        return {
          name: item.name,
          path: item.fullPath,
          url,
          type: item.name.endsWith(".mp3") ? "audio" : "video",
        };
      })
    );
  
    return { folders, files };
  };

  export const fetchMusicFiles = async (folderPath = "") => {
    const musicRef = ref(musicStorage, folderPath);
    const folderContents = await listAll(musicRef);
  
    const folders = folderContents.prefixes.map((prefix) => ({
      name: prefix.name,
      path: prefix.fullPath,
      type: "folder",
    }));
  
    const files = await Promise.all(
      folderContents.items.map(async (item) => {
        const url = await getDownloadURL(item);
        return {
          name: item.name,
          path: item.fullPath,
          url,
          type: item.name.endsWith(".mp3") || item.name.endsWith(".wav") ? "audio" : "other",
        };
      })
    );
  
    return { folders, files };
  };

export const incrementLike = async (fullPath) => {
const safeDocId = fullPath.replaceAll("/", "|"); 
const docRef = doc(firestore, "musics", safeDocId);
  await updateDoc(docRef, {
    likeCount: increment(1),
  });
};

export const decrementLike = async (fullPath) => {
    const safeDocId = fullPath.replaceAll("/", "|");
    const docRef = doc(firestore, "musics", safeDocId);
    await updateDoc(docRef, {
      likeCount: increment(-1),
    })
};